<template>
        <section id="Profile">
        <div class="container px-4 py-5">
            <div class="row flex-lg-row-reverse align-items-center g-5 py-5">
              <div class="col-10 col-sm-8 col-lg-6" data-aos="fade-left">
                <img src="@/images/myphoto.jpg" class="profile animate-shake img-fluid d-block mx-lg-auto" loading="lazy">
              </div>
              <div class="col-lg-6">
                <h1 class="display-5 fw-bold text-body-emphasis lh-1 mb-3">IT and Trade Consultant</h1>
                <p class="lead">Master’s Degree in Business Administration and Bachelor of Computer Science, keen on stirring up creative mind and information into computer projects and working on IT Solution & Trade Consultation in Cambodia.</p>
                <div class="d-grid gap-2 d-md-flex justify-content-md-start">
                  <a href="https://t.me/khlinkCloud" target="_blank"><button type="button" class="btn btn-primary btn-lg px-4 me-md-2">Telegram Chat</button></a>
                  <a href="./docs/somsothea_cv.pdf" target="_blank"><button type="button" class="btn btn-outline-secondary btn-lg px-4">Download CV</button></a>
                </div>
              </div>
            </div>
          </div>
    </section>
</template>